import React from 'react';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const styles = theme => ({
  root: {},
  segment: {
    marginTop: 30,
  },
  segmentCompact: {
    marginTop: 0,
  },
  segmentContent: {
    marginTop: 20,
    padding: 20,
  },
});

const PageSegment = props => {
  const { title, subheader, compact, classes, children } = props;
  return (
    <div
      className={classNames(classes.root, {
        [classes.segmentCompact]: compact,
        [classes.segment]: !compact,
      })}
    >
      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>
      <Typography variant="subtitle2">{subheader}</Typography>
      <Paper className={classes.segmentContent}>{children}</Paper>
    </div>
  );
};

export default withStyles(styles)(PageSegment);
